import React from 'react';
import { UsersIcon, MessageCircleIcon, UserIcon, SearchIcon, BellIcon } from 'lucide-react';
export const Community: React.FC = () => {
  return <div className="p-4 md:p-6 md:ml-64 pb-16 md:pb-6" data-id="element-332">
      <div className="mb-6" data-id="element-333">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-334">
          Community & Coaching
        </h1>
        <p className="text-gray-600" data-id="element-335">Vernetze dich mit Gleichgesinnten</p>
      </div>
      {/* Find Buddies */}
      <section className="mb-8" data-id="element-336">
        <div className="flex justify-between items-center mb-4" data-id="element-337">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-338">
            Finde deinen Longevity Buddy
          </h2>
          <button className="bg-purple-600 text-white rounded-lg px-3 py-1 text-sm font-medium" data-id="element-339">
            Alle anzeigen
          </button>
        </div>
        <div className="relative mb-4" data-id="element-340">
          <input type="text" placeholder="Suche nach Interessen, Alter oder Zielen..." className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-341" />
          <SearchIcon size={18} className="absolute left-3 top-3.5 text-gray-400" data-id="element-342" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-343">
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-344">
            <div className="flex items-start" data-id="element-345">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-346">
                <span className="text-blue-600 font-medium" data-id="element-347">MK</span>
              </div>
              <div className="flex-1" data-id="element-348">
                <div className="flex justify-between items-start" data-id="element-349">
                  <div data-id="element-350">
                    <p className="font-medium text-gray-800" data-id="element-351">Michael K.</p>
                    <p className="text-xs text-gray-500" data-id="element-352">36 Jahre • Berlin</p>
                  </div>
                  <span className="bg-green-100 text-green-600 text-xs px-2 py-1 rounded-full" data-id="element-353">
                    92% Match
                  </span>
                </div>
                <p className="text-sm text-gray-600 mt-2 mb-3" data-id="element-354">
                  Fokus auf Schlafoptimierung, Intervallfasten und
                  Kältetherapie. Suche jemanden für wöchentlichen Austausch.
                </p>
                <div className="flex flex-wrap gap-2 mb-3" data-id="element-355">
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-356">
                    Intervallfasten
                  </span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-357">
                    Kältetherapie
                  </span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-358">
                    Schlaf
                  </span>
                </div>
                <button className="text-purple-600 text-sm font-medium" data-id="element-359">
                  Kontakt aufnehmen
                </button>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-360">
            <div className="flex items-start" data-id="element-361">
              <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-362">
                <span className="text-purple-600 font-medium" data-id="element-363">SL</span>
              </div>
              <div className="flex-1" data-id="element-364">
                <div className="flex justify-between items-start" data-id="element-365">
                  <div data-id="element-366">
                    <p className="font-medium text-gray-800" data-id="element-367">Sarah L.</p>
                    <p className="text-xs text-gray-500" data-id="element-368">42 Jahre • München</p>
                  </div>
                  <span className="bg-green-100 text-green-600 text-xs px-2 py-1 rounded-full" data-id="element-369">
                    88% Match
                  </span>
                </div>
                <p className="text-sm text-gray-600 mt-2 mb-3" data-id="element-370">
                  Interessiert an Biohacking, Supplements und mentaler
                  Gesundheit. Suche Austausch zu Laborwerten und Optimierung.
                </p>
                <div className="flex flex-wrap gap-2 mb-3" data-id="element-371">
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-372">
                    Biohacking
                  </span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-373">
                    Supplements
                  </span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-374">
                    Laborwerte
                  </span>
                </div>
                <button className="text-purple-600 text-sm font-medium" data-id="element-375">
                  Kontakt aufnehmen
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Active Groups */}
      <section className="mb-8" data-id="element-376">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-377">
          Deine aktiven Gruppen
        </h2>
        <div className="space-y-4" data-id="element-378">
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-379">
            <div className="flex items-center justify-between mb-3" data-id="element-380">
              <div className="flex items-center" data-id="element-381">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-382">
                  <UsersIcon size={20} className="text-green-600" data-id="element-383" />
                </div>
                <div data-id="element-384">
                  <p className="font-medium text-gray-800" data-id="element-385">
                    Kältechallenge Gruppe
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-386">
                    28 Mitglieder • Sehr aktiv
                  </p>
                </div>
              </div>
              <div className="flex items-center" data-id="element-387">
                <span className="bg-red-100 text-red-600 text-xs px-2 py-1 rounded-full mr-2" data-id="element-388">
                  12 neu
                </span>
                <button className="text-purple-600 text-sm font-medium" data-id="element-389">
                  Öffnen
                </button>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-3" data-id="element-390">
              Unterstützungsgruppe für die 7-Tage Kältechallenge. Teilt eure
              Erfahrungen und Tipps!
            </p>
            <div className="flex -space-x-2" data-id="element-391">
              <div className="w-6 h-6 rounded-full bg-blue-100 border border-white" data-id="element-392"></div>
              <div className="w-6 h-6 rounded-full bg-purple-100 border border-white" data-id="element-393"></div>
              <div className="w-6 h-6 rounded-full bg-green-100 border border-white" data-id="element-394"></div>
              <div className="w-6 h-6 rounded-full bg-orange-100 border border-white" data-id="element-395"></div>
              <div className="w-6 h-6 rounded-full bg-gray-200 border border-white flex items-center justify-center" data-id="element-396">
                <span className="text-gray-600 text-xs" data-id="element-397">+24</span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-398">
            <div className="flex items-center justify-between mb-3" data-id="element-399">
              <div className="flex items-center" data-id="element-400">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-401">
                  <UsersIcon size={20} className="text-blue-600" data-id="element-402" />
                </div>
                <div data-id="element-403">
                  <p className="font-medium text-gray-800" data-id="element-404">
                    Supplement Optimierer
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-405">45 Mitglieder • Aktiv</p>
                </div>
              </div>
              <div className="flex items-center" data-id="element-406">
                <span className="bg-red-100 text-red-600 text-xs px-2 py-1 rounded-full mr-2" data-id="element-407">
                  3 neu
                </span>
                <button className="text-purple-600 text-sm font-medium" data-id="element-408">
                  Öffnen
                </button>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-3" data-id="element-409">
              Gruppe zum Austausch über Supplements, Dosierungen und persönliche
              Erfahrungen.
            </p>
            <div className="flex -space-x-2" data-id="element-410">
              <div className="w-6 h-6 rounded-full bg-red-100 border border-white" data-id="element-411"></div>
              <div className="w-6 h-6 rounded-full bg-yellow-100 border border-white" data-id="element-412"></div>
              <div className="w-6 h-6 rounded-full bg-indigo-100 border border-white" data-id="element-413"></div>
              <div className="w-6 h-6 rounded-full bg-pink-100 border border-white" data-id="element-414"></div>
              <div className="w-6 h-6 rounded-full bg-gray-200 border border-white flex items-center justify-center" data-id="element-415">
                <span className="text-gray-600 text-xs" data-id="element-416">+41</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Expert Sessions */}
      <section className="mb-8" data-id="element-417">
        <div className="flex justify-between items-center mb-4" data-id="element-418">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-419">
            Kommende Experten-Sessions
          </h2>
          <button className="text-purple-600 text-sm font-medium" data-id="element-420">
            Alle anzeigen
          </button>
        </div>
        <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-421">
          <div className="p-4 border-b border-gray-100" data-id="element-422">
            <div className="flex items-center justify-between" data-id="element-423">
              <div className="flex items-center" data-id="element-424">
                <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center mr-3" data-id="element-425">
                  <UserIcon size={20} className="text-indigo-600" data-id="element-426" />
                </div>
                <div data-id="element-427">
                  <p className="font-medium text-gray-800" data-id="element-428">Dr. Markus Weber</p>
                  <p className="text-xs text-gray-500" data-id="element-429">
                    Longevity-Spezialist • Morgen, 18:00
                  </p>
                </div>
              </div>
              <button className="bg-indigo-600 text-white px-3 py-1 rounded-lg text-xs font-medium" data-id="element-430">
                Teilnehmen
              </button>
            </div>
            <p className="text-sm text-gray-600 mt-2" data-id="element-431">
              "Neueste Erkenntnisse zur NAD+ Optimierung und zellulärer
              Gesundheit"
            </p>
          </div>
          <div className="p-4 border-b border-gray-100" data-id="element-432">
            <div className="flex items-center justify-between" data-id="element-433">
              <div className="flex items-center" data-id="element-434">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-435">
                  <UserIcon size={20} className="text-green-600" data-id="element-436" />
                </div>
                <div data-id="element-437">
                  <p className="font-medium text-gray-800" data-id="element-438">Dr. Julia Schmidt</p>
                  <p className="text-xs text-gray-500" data-id="element-439">
                    Ernährungsmedizinerin • Freitag, 19:30
                  </p>
                </div>
              </div>
              <button className="bg-green-600 text-white px-3 py-1 rounded-lg text-xs font-medium" data-id="element-440">
                Teilnehmen
              </button>
            </div>
            <p className="text-sm text-gray-600 mt-2" data-id="element-441">
              "Intervallfasten und ketogene Ernährung: Synergien für die
              Langlebigkeit"
            </p>
          </div>
          <div className="p-4" data-id="element-442">
            <div className="flex items-center justify-between" data-id="element-443">
              <div className="flex items-center" data-id="element-444">
                <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-445">
                  <UserIcon size={20} className="text-purple-600" data-id="element-446" />
                </div>
                <div data-id="element-447">
                  <p className="font-medium text-gray-800" data-id="element-448">
                    Prof. Thomas Müller
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-449">
                    Schlafforscher • Nächste Woche
                  </p>
                </div>
              </div>
              <button className="bg-purple-600 text-white px-3 py-1 rounded-lg text-xs font-medium" data-id="element-450">
                Erinnern
              </button>
            </div>
            <p className="text-sm text-gray-600 mt-2" data-id="element-451">
              "Schlafoptimierung für bessere Regeneration und kognitive
              Gesundheit"
            </p>
          </div>
        </div>
      </section>
      {/* Coaching */}
      <section data-id="element-452">
        <div className="bg-purple-50 rounded-xl p-6" data-id="element-453">
          <div className="flex items-center mb-4" data-id="element-454">
            <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center mr-4" data-id="element-455">
              <MessageCircleIcon size={24} className="text-purple-600" data-id="element-456" />
            </div>
            <div data-id="element-457">
              <h3 className="font-bold text-gray-800" data-id="element-458">Persönliches Coaching</h3>
              <p className="text-sm text-gray-600" data-id="element-459">
                Erhalte individuelle Betreuung von Experten
              </p>
            </div>
          </div>
          <p className="text-sm text-gray-700 mb-4" data-id="element-460">
            Mit unserem Coaching-Programm erhältst du Zugang zu persönlichen
            Beratern, die dir helfen, deine Gesundheitsziele zu erreichen. Teile
            deine Daten und erhalte maßgeschneiderte Beratung.
          </p>
          <div className="flex flex-col sm:flex-row justify-between space-y-3 sm:space-y-0 sm:space-x-4" data-id="element-461">
            <button className="bg-purple-600 text-white px-4 py-2 rounded-lg text-sm font-medium" data-id="element-462">
              Coach finden
            </button>
            <button className="bg-white text-purple-600 border border-purple-600 px-4 py-2 rounded-lg text-sm font-medium" data-id="element-463">
              Mehr erfahren
            </button>
          </div>
        </div>
      </section>
    </div>;
};